const TAWK_PANEL_MAX_HEIGHT = 640
const TAWK_VIEWPORT_PADDING = 24

let tawkReady = false
let tawkPendingOpen = false
let tawkScriptRequested = false
let tawkResizeListenerAttached = false
let tawkBubbleVisible = false

function getTawkApi() {
  return window.Tawk_API
}

function isAdminGuard(guard) {
  return guard === 'admin'
}

function resolveEmbedSrc(options = {}) {
  if (isAdminGuard(options.guard)) {
    return options.adminEmbedSrc || options.embedSrc
  }

  return options.embedSrc
}

function markChatOpen(isOpen) {
  document.body.classList.toggle('auth-tawk-chat-open', isOpen)
  document.body.style.overflow = isOpen ? 'hidden' : ''

  if (isOpen) {
    updateTawkPanelHeight()
    attachTawkResizeListener()
    return
  }

  document.documentElement.style.removeProperty('--auth-tawk-panel-max-height')
}

function updateTawkPanelHeight() {
  const maxHeight = Math.max(
    320,
    Math.min(TAWK_PANEL_MAX_HEIGHT, window.innerHeight - TAWK_VIEWPORT_PADDING),
  )

  document.documentElement.style.setProperty('--auth-tawk-panel-max-height', `${maxHeight}px`)
}

function attachTawkResizeListener() {
  if (tawkResizeListenerAttached) {
    return
  }

  window.addEventListener('resize', updateTawkPanelHeight, { passive: true })
  tawkResizeListenerAttached = true
}

function styleTawkFrames() {
  document.querySelectorAll('iframe[src*="tawk.to"]').forEach((frame) => {
    frame.classList.add('auth-tawk-frame')
  })
}

function hideTawkBubble() {
  const api = getTawkApi()

  if (typeof api?.hideWidget === 'function') {
    api.hideWidget()
  }

  markChatOpen(false)
}

function syncTawkBubbleVisibility() {
  if (!tawkReady) {
    return
  }

  const api = getTawkApi()

  if (tawkBubbleVisible) {
    if (typeof api?.showWidget === 'function') {
      api.showWidget()
    }

    markChatOpen(false)
    return
  }

  hideTawkBubble()
}

function showTawkChat() {
  const api = getTawkApi()

  if (!tawkReady || typeof api?.maximize !== 'function') {
    return false
  }

  updateTawkPanelHeight()

  if (typeof api.showWidget === 'function') {
    api.showWidget()
  }

  api.maximize()
  markChatOpen(true)
  styleTawkFrames()

  return true
}

function loadTawkScript(embedSrc) {
  if (tawkScriptRequested || document.querySelector('script[src*="embed.tawk.to"]')) {
    return
  }

  if (!embedSrc) {
    return
  }

  tawkScriptRequested = true
  window.Tawk_LoadStart = new Date()

  const script = document.createElement('script')
  script.async = true
  script.src = embedSrc
  script.charset = 'UTF-8'
  script.setAttribute('crossorigin', '*')

  const firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(script, firstScript)
}

export function initAuthTawk(options = {}) {
  if (!document.body.classList.contains('auth-login-page')) {
    return
  }

  const embedSrc = resolveEmbedSrc(options)
  const admin = isAdminGuard(options.guard)

  document.body.classList.toggle('auth-tawk--admin', admin)
  document.body.classList.toggle('auth-tawk--web', !admin)

  window.Tawk_API = window.Tawk_API || {}

  window.Tawk_API.customStyle = {
    zIndex: 10050,
    visibility: {
      desktop: {
        position: 'br',
        xOffset: 20,
        yOffset: 20,
      },
      mobile: {
        position: 'br',
        xOffset: 12,
        yOffset: 12,
      },
      bubble: {
        rotate: '0deg',
        xOffset: 0,
        yOffset: 0,
      },
    },
  }

  window.Tawk_API.onLoad = function onAuthTawkLoad() {
    tawkReady = true
    document.body.classList.add('auth-tawk-ready')
    syncTawkBubbleVisibility()
    styleTawkFrames()

    if (tawkPendingOpen) {
      tawkPendingOpen = false
      showTawkChat()
    }
  }

  window.Tawk_API.onChatMaximized = function onAuthTawkMaximized() {
    markChatOpen(true)
    styleTawkFrames()
  }

  window.Tawk_API.onChatMinimized = function onAuthTawkMinimized() {
    if (tawkBubbleVisible) {
      markChatOpen(false)
      return
    }

    hideTawkBubble()
  }

  window.Tawk_API.onChatHidden = function onAuthTawkHidden() {
    hideTawkBubble()
  }

  loadTawkScript(embedSrc)
}

export function setAuthTawkBubbleVisible(isVisible) {
  tawkBubbleVisible = isVisible
  syncTawkBubbleVisibility()
}

export function openAuthLiveChat() {
  if (showTawkChat()) {
    return true
  }

  tawkPendingOpen = true
  return false
}

export function isAuthTawkReady() {
  return tawkReady
}
